import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { CallEntity } from './call.entity';
import { UserEntity } from './user.entity';

// PD-17459 — widened so per-rep call counts over a date range read the index
// alone (migration 1792856104589-WidenCallUserDateIndex).
@Index('call_user_date_index', ['date', 'fkUserId', 'duration', 'deletedDate'], {})
@Index('call_user_externalId_uindex', ['externalId'], { unique: true })
@Index('call_user_externalPartyPhone_index', ['externalPartyPhone'], {})
@Index('fk_call__id', ['fkCallId'], {})
@Index('fk_user__id', ['fkUserId'], {})
// PD-14960 — the column order the legacy platform created this index with and
// most tenants have: one rep's external calls, newest first, read straight
// from the index (the dialer's Recents and Frequent tabs). This entity used to
// declare (_deleted_userId, date, isInternal, fk_user__id), so tenants the
// database sync created got that order, which cannot serve a per-rep read;
// migration 1793205016126-ReorderCallUserUserDateIndex rebuilds those.
@Index(
	'fk_user__id_isInternal__deleted_userId_date',
	['fkUserId', 'isInternal', 'deletedUserId', 'date'],
	{},
)
@Entity('call_user')
export class CallUserEntity extends BaseEntity {
	@Column('varchar', {
		name: 'externalId',
		nullable: true,
		unique: true,
		length: 64,
	})
	public externalId!: string | null;

	@Column('datetime', { name: 'date', nullable: true })
	public date!: Date | null;

	@Column('varchar', { name: 'externalPartyPhone', nullable: true, length: 64 })
	public externalPartyPhone!: string | null;

	@Column('varchar', { name: 'externalPartyName', nullable: true, length: 255 })
	public externalPartyName!: string | null;

	@Column('varchar', { name: 'phoneExtensionId', nullable: true, length: 255 })
	public phoneExtensionId!: string | null;

	@Column('int', { name: 'duration', nullable: true })
	public duration!: number | null;

	@Column('varchar', { name: 'direction', nullable: true, length: 255 })
	public direction!: string | null;

	@Column({ type: 'boolean', name: 'isInternal', width: 1, default: () => "'0'" })
	public isInternal!: boolean;

	@Column('int', { name: 'fk_call__id', nullable: true, unsigned: true })
	public fkCallId!: number | null;

	@Column('int', { name: 'fk_user__id', nullable: true, unsigned: true })
	public fkUserId!: number | null;

	@ManyToOne(() => CallEntity, (call) => call.callUsers, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: 'fk_call__id', referencedColumnName: 'id' }])
	public fkCall!: CallEntity;

	@ManyToOne(() => UserEntity, (user) => user.callUsers, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: 'fk_user__id', referencedColumnName: 'id' }])
	public fkUser!: UserEntity;
}
